import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  state: string
}
const InstructionStateChip: React.FC<ComponentProps> = ({ state }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (['CANCELLED'].includes(state)) {
    color = 'error'
    variant = 'outlined'
  } else if (['PENDING', 'IN_PROGRESS'].includes(state)) {
    color = 'primary'
    variant = 'outlined'
  } else if (state === 'PROCESSED') {
    color = 'success'
    variant = 'outlined'
  }

  return (
    <>
      <Tooltip title={state} TransitionComponent={Zoom} arrow placement="bottom">
        <Chip label={state} variant={variant} color={color}/>
      </Tooltip>
    </>
  )
}

export default InstructionStateChip
